// reducer.js
import { GET_USER } from "./actionTypes";

const INIT_STATE = {
  users: {},
  loading: false,
};

const usersReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_USER:
      return {
        ...state,
        loading: true,
        users: action.payload,
      };
    default:
      return state;
  }
};

export default usersReducer;
